import { loadPage } from "./load-page";

loadPage();
